import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledStoryWithQuestions = styled.div`
  width: 100%;
  flex: 1;
  color: ${Colors.text};
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .game-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    flex: 1;
    font-size: 25px;
    padding: 0.5% 10%;
    background-color: ${Colors.background};

    .page {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .buttons {
      pointer-events: none;
      box-sizing: border-box;
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      margin-top: 20px;
      .navButton {
        pointer-events: all;
        color: ${Colors.primary};
        transition: all 0.3s;
        display: flex;
        flex-direction: column;
        align-items: center;
        &.hide {
          opacity: 0;
        }
        &:hover {
          transform: scale(1.1) translateY(-5px);
          color: ${Colors.primary};
        }
        .icon {
          font-size: 48px;
        }
        .text {
        }
      }
    }
  }

  @media only screen and (max-height: 500px) and (orientation: landscape) {
    .game-container {
      font-size: 18px;
      .buttons {
        .navButton {
          .icon {
            font-size: 32px;
          }
        }
      }
    }
  }
`;
